import { Component, ElementRef, EventEmitter, Output, ViewChild,ChangeDetectorRef, OnDestroy, Input } from '@angular/core';
import {FormBuilder, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import { FlightService } from 'src/app/services/flight.service';
import { DataService } from 'src/app/services/data.service';
import { MatStepper } from '@angular/material/stepper';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { DatePipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatSelectionList } from '@angular/material/list';
import { DomSanitizer} from '@angular/platform-browser';
import { SettingsService } from 'src/app/services/settings.service';
import {TestComponent} from 'src/app/components/test/test.component'
import {CarrierCodeService} from '../../services/carrier-code.service';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { UserService } from 'src/app/services/user.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from "../../../environments/environment"
import { Router ,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.css'],
 
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {displayDefaultIndicatorType: false},
    },
  ],
})
export class PaymentDetailsComponent implements OnDestroy {
  countdown: number = 15;
interval: any;
  currentStep: number = 1;
  totalBalance:any
  nextStep() {
    this.currentStep = Math.min(this.currentStep + 1, 3);
  }

  prevStep() {
    this.currentStep = Math.max(this.currentStep - 1, 1);
  }

  @ViewChild('PaymentType') PaymentType!: MatSelectionList;

  // @ViewChild(MatStepper) stepper!: MatStepper;
  
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  
  @Output() flightBooking:EventEmitter<string>= new EventEmitter();  
  @Output() hideSideBar:EventEmitter<string>= new EventEmitter();
  userUuid:any
  
  acceptTerm:any='true'
  outputMessage:string="close";
  showSpiner:boolean=false
  showNext:boolean=false
  pnrNo:any
  pnrData:any
  flightList:any
  orderId:any
  showMore:any
  carrierCode = []
firstFormGroup = this._formBuilder.group({
  firstCtrl: ['', Validators.required],
});
secondFormGroup = this._formBuilder.group({
  secondCtrl: '',
});
isOptional = false;
userType:any;
duplicateScreen:boolean=false
loginUserType:any
constructor(private Router:Router,private LoginService:LoginService,private UserService:UserService,private SettingsService:SettingsService,private sanitizer :DomSanitizer,private cdr: ChangeDetectorRef,private CarrierCodeService:CarrierCodeService,
   private userInfoService : UserInfoService, private toastMsgService : ToastmsgService,  private dialogService : DialogService,
  private _formBuilder: FormBuilder,private FlightService:FlightService,private order:DataService,private PaymentConfigService:PaymentConfigService,private DataEntityService:ReportingConfigService) {
    this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
    this.ENABLE_TRIP_MGMT()
    this.userType=userInfoService.getUserType();
    this.userType=this.userType.toUpperCase()

    this.carrierCode=this.CarrierCodeService.carrierCode()
  this.order.portMessage.subscribe((message:any) => this.orderId = message)
  
  if( this.userType!='AGENT'){
this.dataEntitylist()}
  if(this.orderId?.pnr){
    // console.log(this.orderId?.pnr)
    this.pnrNo=this.orderId?.pnr
    
    this.pnrRetreive()
    this.showNext=true
    
    this.currentStep=2
  }else{
      this.duplicateData()

    
    this.cardPassthroughList()
    if(this.orderId.paymentConfig===null||this.orderId.paymentConfig===undefined||this.orderId.paymentConfig===""||this.orderId.paymentConfig.status.length===0){
      this.dialogService.open({msg : "No Payment Medium Enabled, Please contact your TravelDesk.",title : "Warning",buttonType : "tag"})
  
      this.dialogService.onResponse((response :  string) => {
           
        if(response=="Back to Search Page") {
          // window.location.href="/app/flight"
          this.clearSesson()
            window.close();
        }
      })
    }

    if(this.orderId.userBookingContext==='P'){
      this.paymentStatus()
  
    }

  }
  this.userUuid=this.userInfoService.getUserUuid()
this.GetBalance()

// console.log(this.userUuid)
}

backClick(){
  window.location.reload()
  this.myOutput.emit(this.outputMessage);
}
bookingRequest:any
verifyShow:boolean=false
verifyData(){
 
  let json:any = sessionStorage.getItem('json');
  this.bookingRequest=JSON.parse(json).bookingRequest
  this.verifyShow=true
  // console.log(this.bookingRequest)
}


booking(){
const phoneRegex = /^[\+]{0,1}[0-9\s]{8,14}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const phone = this.billingEntity?.phone || null;
  const email = this.billingEntity?.email || null;
if(phone||email){
  if (!phoneRegex.test(phone || '') || !emailRegex.test(email || '')) {
    this.toastMsgService.setMsg({
      msg: 'Please enter a valid GST Email address and GST phone number',
      msgTitle: "Warning",
      msgType: "W"
    });
    return; // stop booking flow
  }}
  this.getFlightList()
  // this.flightBooking.emit(this.outputMessage);
  // this.bookingData()
  this.OrderUpdate()
}

bookingData(){
  
  this.showSpiner=true
  this.FlightService
  .getbooking(this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {

      this.showSpiner=false
      if(res) {
       let data:any
       data=res?.result  
       //this.firstFormGroup.value.firstCtrl=data.pnrNumber
      //  this.firstFormGroup = this._formBuilder.group({
      //   firstCtrl: [data?.pnrNumber, Validators.required],
        
      // });
      let pnrData:any=''

if(data){
  // console.log(res)
      data.forEach((item:any)=>{
        let sector:any=''
        if(item?.fromAirport){
          sector=item?.fromAirport +` to `+ item?.toAirport
        }else{
          sector=item?.sector
      
        }
      if( res.resStatus==="OK"){

        this.hideSideBar.emit(this.outputMessage);

        this.pnrNo=item?.pnrNumber

        this.pnrRetreive()
        this.startTimer()
        this.showNext=true
       
        this.currentStep=2
        this.clearSesson()

        // pnrData+=item?.fromAirport +' to '+ item?.toAirport+ " PNR ("+this.pnrNo+") has been successfully generated ! \n"
if(this.pnrNo){
  
        pnrData+=sector+ ` (`+this.pnrNo+`) Success , Processing the Ticket  ! \n`
        // this.toastMsgService.setMsg({msg : pnrData,msgTitle:  "Success", msgType : "I"});
}else{
  pnrData+=sector+ ` (`+item?.errorDetails?.errorData?.errorMessage+`) Failed  ! \n`
  // this.toastMsgService.setMsg({msg : pnrData,msgTitle:  "Success", msgType : "I"});

}
this.dialogService.open({msg : pnrData,title : "Confirmation",buttonType : "Ok"})

        this.dialogService.onResponse((response :  string) => {
         
          if(response=="OK") {
          


          }})
          
      }else if(res.resStatus==="BAD_REQUEST"){
        if(item?.errorDetails?.errorData?.errorMessage==="Price changed"){

          pnrData +=sector + `(`+ `Price Jumped You Still to Continue`+`)! \n`
          // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
   this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "priceChange"})
         
          this.dialogService.onResponse((response :  string) => {
           
            if(response=="Back to Search Page") {
              this.clearSesson()
              // window.location.href="/app/flight"
                window.close();
  
            }else if(response=="Accepted"){
              window.location.reload()

            }})



        }else{

         pnrData +=sector + `(`+ item?.errorDetails?.errorData?.errorMessage+`)! \n`
        // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
 this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "tag"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            this.clearSesson()
            // window.location.href="/app/flight"


           
              window.close();

            


            
          }})}
      }else if(res.resStatus==="CONFLICT"){
        pnrData +=item?.errorDetails?.errorData
        // this.toastMsgService.setMsg({msg :pnrData,msgTitle:  "Warning", msgType : "W"});
 this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "tag"})
       
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            this.clearSesson()
            // window.location.href="/app/flight"


           
              window.close();

            


            
          }})
      }

    })}else{


      this.dialogService.open({msg : "PNR not generated !",title : "Warning",buttonType : "tag"})
     
      this.dialogService.onResponse((response :  string) => {
       
        if(response=="Back to Search Page") {
          this.clearSesson()
          // window.location.href="/app/flight"

          window.close();

          
        }})
    }
    
      } else {  


   
        this.dialogService.open({msg : "PNR not generated !",title : "Warning",buttonType : "tag"})
     
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            this.clearSesson()
            // window.location.href="/app/flight"

            window.close();

            
          }})

      //   let pnrData:any
      //   pnrData=res?.message
      //   if(pnrData){
      //     this.dialogService.open({msg : pnrData,title : "Warning",buttonType : "tag"})
       
      //     this.dialogService.onResponse((response :  string) => {
           
      //       if(response=="Back to Search Page") {
            
      //         window.location.href="/app/flight"

              
      //       }})
        
      // }else{
      //   this.dialogService.open({msg : 'PNR not generated !',title : "Warning",buttonType : "tag"})
       
      //   this.dialogService.onResponse((response :  string) => {
         
      //     if(response=="Back to Search Page") {
          
      //       window.location.href="/app/flight"

            
      //     }})
      // }
      } 
    },error : (err) => {
      this.showSpiner=false
   
        this.dialogService.open({msg : "PNR not generated !",title : "Warning",buttonType : "tag"})
     
        this.dialogService.onResponse((response :  string) => {
         
          if(response=="Back to Search Page") {
            this.clearSesson()
            // window.location.href="/app/flight"

            window.close();

            
          }})
      // this.toastMsgService.setMsg({msg : "PNR not generated !",msgTitle:  "Warning", msgType : "W"});

    }
  }
)
}

pnrRetreive(){
  this.showMore=true
  this.FlightService.getAllData(this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {
      if(res) {
        this.showMore=false
       let data:any
       data=res  
       this.pnrData=data
       

      //  this.pnrData.type="upload"

      //  this.order.deliverMsg(this.pnrData)
      //  this.test=true
   
      //  setTimeout(() => {
      //    this.test=false
      //  }, 1);    
      } else {    
      } 
    },error : (err) => {
      

      this.showMore=false

    }
  }
)
}
convertToISOStringFormat(dateString:any) {
  // Remove the ' 00:00' part and then add 'Z' at the end
  const isoDateString = dateString?.replace('00.000 00:00', '00.000Z');
  return isoDateString;
}
timeFormate(date:any){
  date=this.convertToISOStringFormat(date)
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'hh:mma');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

}
airPortFilter(item:any){
    
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.name
return item}else{
  return item
}
}
cityFilter(item:any){
    
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.city
return item}else{
  return item
}
}
getFlightList(){
   
  this.FlightService
  .getFlightList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       this.flightList=data
   
      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}
converter(item:any){
  const totalMinutes = item ;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  item=`${hours}h ${remainingMinutes}m`
  return item
}
dateFormate(date:any){

  date=this.convertToISOStringFormat(date)
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
acceptFTerm:any='true'
termConditions(item:any){
  // console.log(this.acceptTerm)
  this.acceptTerm=item
  this.acceptFTerm=item
}
backFlight()
{
window.location.href="/app/flight"
}
generateTicket(){
  this.FlightService
    .downloadPdf(this.pnrData?.orderId)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)

        //  var fileName = this.orderId.orderNumber+"_Invoice.pdf";
        //       var a = document.createElement("a");
        //         var blob = data;
        //         this.pdfFileName = fileName;
        //         var file = new Blob([blob], {type: 'application/pdf'});
        //         var fileURL = window.URL.createObjectURL(file);
        //         this.pdfblob = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);
        //         console.log( this.pdfblob)
        //         console.log( this.pdfFileName)

        var fileName = "Ticket_"+this.pnrData?.pnrNumbers?.replace(',','_') + ".pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
 a.download = fileName;
window.open(a.href, '_blank');

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
//a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }

GetBalance(){

  this.PaymentConfigService
  .getBalance(this.userUuid)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.totalBalance=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
openTooltip() {
  this.GetBalance()
  const tooltipElement = document.querySelector('.mat-tooltip');
  
  // Check if the tooltip is already open
  if (tooltipElement) {
    tooltipElement.classList.add('mat-tooltip-show');
  }
}
ngAfterViewInit() {
  // Assuming "deposit" is the value you want to auto-select
  let mapstatus:any=[]
  if(this.orderId.userBookingContext==='P'){
    mapstatus=this.orderId.paymentConfig?.status?.filter((map:any)=>map.isPersonalEnabled===true)

  }else{
    mapstatus=this.orderId.paymentConfig?.status?.filter((map:any)=>map.isBusinessEnabled===true)

  }
  // console.log(mapstatus)
  const depositOption = this.PaymentType?.options.find((option:any) => option?.value === mapstatus[0].mediumName);
 const ticketOption=this.ticketIssuance?.options.find((option:any) => option?.value === "true");
  if(ticketOption){
    ticketOption._setSelected(true); 
  }
 if (depositOption) {
    depositOption._setSelected(true); // Use _setSelected to programmatically select the option
  }

  const depositPassOption = this.PassthroughPayment?.options.find((option:any) => option?.value === 'default');
  
  if (depositPassOption) {
    depositPassOption._setSelected(true); // Use _setSelected to programmatically select the option
   }
  this.cdr.detectChanges();
  this.OrderId()
  
}
// ticketIssuance:any=true
@ViewChild('ticketIssuance') ticketIssuance!: MatSelectionList;

OrderId(){
  let request:any={}
  // console.log(this.fopType)
  this.fopType=this.PaymentType?.selectedOptions?.selected[0]?.value;

  if(this.fopType==='VIRTUAL_CARD'){
    this.creditList()

    request["paymentMedium"]=this.PaymentType?.selectedOptions?.selected[0]?.value;
    request["cardNo"]=this.cardNo
    request["ticketIssuance"]=this.ticketIssuance?.selectedOptions?.selected[0]?.value;


  if(this.cardNo){
    this.FlightService
    .OrderId(this.orderId.orderNumber,request)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)
        
        } else {    
        } 
      },error : (err) => {
  
  
      }
    }
  )}
  
  }else  if(this.fopType==='MOTO'){
    this.creditMOTOList()

    request["paymentMedium"]=this.PaymentType?.selectedOptions?.selected[0]?.value;
    request["cardNo"]=this.cardNo
    request["ticketIssuance"]=this.ticketIssuance?.selectedOptions?.selected[0]?.value;


  if(this.cardNo){
    this.FlightService
    .OrderId(this.orderId.orderNumber,request)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
this.convenienceCharges=data?.convenienceCharges
    this.convenienceChargesChange.emit(this.convenienceCharges);

        //  console.log(data)
        
        } else {    
        } 
      },error : (err) => {
  
  
      }
    }
  )}
  
  }
  else{
    request["paymentMedium"]=this.PaymentType?.selectedOptions?.selected[0]?.value;

    request["ticketIssuance"]=this.ticketIssuance?.selectedOptions?.selected[0]?.value;

  this.FlightService
  .OrderId(this.orderId.orderNumber,request)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
this.convenienceCharges=data?.convenienceCharges
    this.convenienceChargesChange.emit(this.convenienceCharges);

      //  console.log(data)
      
      } else {    
      } 
    },error : (err) => {


    }
  }
)}

}
 @Input() convenienceCharges:any={
  "charges": 0,
        "taxValue": 0,
        "convenienceRate": ""
}
  @Output() convenienceChargesChange = new EventEmitter<any>();

displaymarkcommJSON(item: any): string {

  let result:any={ ...item }

  // Helper function to replace null with undefined
  const replaceNullWithUndefined = (obj: any): any => {
    if (obj === null) {
      return undefined;
    }
    if (Array.isArray(obj)) {
      return obj.map(replaceNullWithUndefined);
    }
    if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, replaceNullWithUndefined(value)])
      );
    }
    return obj;
  };

  // Replace null with undefined in the result object
  const modifiedResult = replaceNullWithUndefined(result);

  // Convert the modified result to a JSON string with 4-space indentation
  // return JSON.stringify(modifiedResult, (key, value) => value === undefined ? undefined : value, 4);
  const jsonString = JSON.stringify(modifiedResult, null, 4)
        .replace(/[\[\]]/g, '')      // Remove square brackets
        .replace(/[{}]/g, '');      // Replace curly braces with commas

    // Replace "key": with <b>key</b>: for HTML bold
    const htmlFormatted = jsonString.replace(/"([^"]+)":/g, '<b>$1</b>:');

    return  `${htmlFormatted}`;
}
fligthNameFilter(item:any){
  if(item){
  let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0].flightName
   return flightName
 }}else{
  return item
 }
  }

  
  pdfFileName:any
  pdfblob:any
  generatePDF(){
    this.FlightService
    .downloadPdf(this.pnrData?.orderId)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)

       

        var fileName = "Ticket_"+this.pnrData?.pnrNumbers?.replace(',','_') + ".pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {


      }
    }
  )
  
  }
  @ViewChild(TestComponent) childComponent!: TestComponent;
  test:boolean=false
  print(){
this.generateTicket()
// this.pnrData.type="print"

//     this.order.deliverMsg(this.pnrData)
//     this.test=true

//     setTimeout(() => {
//       this.test=false
//     }, 1);
   
      
  }
  download(){
    this.generatePDF()
    // this.pnrData.type="download"

    // this.order.deliverMsg(this.pnrData)
    // this.test=true

    // setTimeout(() => {
    //   this.test=false
    // }, 1);
  }
  fopType:any
  cardNo:any
  CreditData:any

  onChageFop(){
    if(this.fopType==='CASH'){
    this.cardNo=""
    }else{
      this.creditList()
    }
  }
  cardData(item:any){
    if(this.fopType==='MOTO'){
      if(this.checkPassThrough==='C'){
        this.cardPassThroughNo=item?.value
        this.orderSelectionUpdate()

      }

    }
  this.OrderId()
  /*if(item.expiryDate){
  this.cardExpMonth=this.separateValues(item.expiryDate).month
  this.cardExpYear=this.separateValues(item.expiryDate).year
  }*/
  }
creditList(){

  this.PaymentConfigService
  .creditCardList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
     this.CreditData=data
    //  console.log(this.CreditData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
creditMOTOList(){

  this.PaymentConfigService
  .MOTOCardList(this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data=res
        let datas:any=data?.body
     this.CreditData=datas?.customerChargeToOptions?.cardDetails||[]
     
    //  console.log(this.CreditData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}



flightlogoFilter(item:any){
  
  if(item){
     let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0]?.logo
   return flightName
 }
  }else{return item}
 }
 onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
showGstInfo:boolean=false
 onClickGstInfo(){
this.showGstInfo=!this.showGstInfo
 }
 showadvancePrice:boolean=false
 onClickPricing(){
  this.showadvancePrice=!this.showadvancePrice
}

formatTotalPrice(item:any) {
  const numericPrice = parseFloat(item);
  if (!isNaN(numericPrice)) {
    return numericPrice.toFixed(2) + ' INR';
  }
  return 'N/A';

}
DataEntity:any
billingEntity:any
dataEntitylist(){
  // console.log(this.orderId)
  this.DataEntityService
 .listEntities(this.orderId?.paymentConfig?.userUid)
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.DataEntity=data
     let entity:any=[]
     if(this.orderId?.entityRefId){
     entity=this.DataEntity.filter((item:any)=>item.entityRefId===this.orderId?.entityRefId)
     this.billingEntity=entity[0]
    }
      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}

matchbase64(text:any){
const baseTypeMatch = text.match(/data:(.*?);/);
const baseType = baseTypeMatch ? baseTypeMatch[1] : null;
return baseType
}
disabledDownload:boolean=false
startTimer(): void {
  this.interval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
      this.disabledDownload=true
if(this.countdown===0){
  this.pnrRetreive()

}
    } else {
      this.disabledDownload=false
      clearInterval(this.interval);

      // Timer has completed. You can add more logic here if needed.
    }
  }, 1000); // 1000 milliseconds = 1 second

  
}

submitRequest(){
  this.toastMsgService.setMsg({msg : "Submit Request Successfully!",msgTitle : "Success", msgType : "I"});

}
trip2Enable:any=''
tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
          this.tripEnable=true
        }else 
        if(res.rule==='2'){
          this.trip2Enable='enable'
          this.tripEnable=false
                    }else{
          this.tripEnable=false

        }

       }
 
      }else{

      }},error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  
}


ShowDuplicateBookings:boolean=false
duplicateBookingList:any
duplicateData(){
  // console.log()
let json:any=sessionStorage.getItem('json')
let data:any= JSON.parse(json)

  let request:any={
    "orderPassengerDetailsList":data?.bookingRequest?.passengerDetails,
    
    "segments":data?.segment ,
    
}
  this.FlightService.show_Duplicate(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let checkData:any=this.getKeys(res?.body)

   
this.duplicateBookingList=res?.body
        for(let i of checkData){
            if(this.duplicateBookingList[i].length!=0){
                  if(this.paymentPGStatus!='P'){

                    this.ShowDuplicateBookings=true

              }
            }
          // if(checkData[i].length!=0){
          //   this.ShowDuplicateBookings=true

          // }
        }
    }else{

    }},error : (err) => {

      console.error("Error in fetching data");
    }
  }
)

}
getKeys(obj: any): string[] {
  if(obj){
    return Object.keys(obj);

  }
  return []
}

closeWindow(){
  window.close();

}
onModifyClick(data:any){
  
  let url="/app/modify-cart?id="+data
  window.open(url)
  

}




accept_cancel(command:any){

  let request:any={
    "dupeValidation":{
      "validated":true,
      "action":command
      }
    
}
  this.FlightService.accept_cancelDuplicate(request,this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {
      if(command==='Cancel'){
        this.toastMsgService.setMsg({msg : "Cancelled!",msgTitle : "Success", msgType : "I"});

      this.closeWindow()

     }
      else if(command==='Accept'){
        this.toastMsgService.setMsg({msg : "Accepted!",msgTitle : "Success", msgType : "I"});
        this.ShowDuplicateBookings=false
      }
      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed!",msgTitle : "Warning", msgType : "W"});
      
      console.error("Error in fetching data");
    }
  }
)

}



showPayNow(totalAmount:any,ticketAmount:any){
 

  if(totalAmount&&ticketAmount){
    
if(totalAmount>=ticketAmount){
  return true
}

  return false
}
  return true
}
amount: any;
  currency: string = 'INR';

  addAmount(totalAmount:any,ticketAmount:any){
   
    this.EnablePG()

    if(ticketAmount){
      // this.amount=ticketAmount-totalAmount
      // this.amount=ticketAmount+this.convenienceCharges?.charges+this.convenienceCharges?.taxValue
      this.amount =
  (ticketAmount || 0) +
  (Number(this.convenienceCharges?.charges) || 0) +
  (Number(this.convenienceCharges?.taxValue) || 0);
      this.initiatePayment()
    }

  }
  initiatePayment() {
    let pgPaymentPurpose:any=''
   if(this.orderId.userBookingContext==='P'){
    pgPaymentPurpose='PB'
   }else{
    pgPaymentPurpose='AB'

   }

    const paymentDetails = {
      amount: this.amount,
      currency: this.currency,
      pgPaymentPurpose:pgPaymentPurpose,
      serviceOrderReference:this.orderId.orderNumber
      // redirectUrl: this.router.navigate(["/app/flight"]),
      // cancelUrl: this.router.navigate(["/app/flight"])
    };
    sessionStorage.setItem('urlAgentPath',this.Router.routerState.snapshot.url);

    this.LoginService.initiatePayment(paymentDetails).subscribe(response => {

      const { accessCode, encRequest } = response.body;
      

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = environment.hdfcUrl+'/transaction/transaction.do?command=initiateTransaction';
      form.target = '_self';  

      const accessCodeInput = document.createElement('input');
      accessCodeInput.type = 'hidden';
      accessCodeInput.name = 'access_code';
      accessCodeInput.value = accessCode;
      form.appendChild(accessCodeInput);

      const encRequestInput = document.createElement('input');
      encRequestInput.type = 'hidden';
      encRequestInput.name = 'encRequest';
      encRequestInput.value = encRequest;
      form.appendChild(encRequestInput);

      document.body.appendChild(form);
      form.submit();
    
    });
  }
  clearSesson(){
    const sessionKeys = [
      'json', 
      'advancetotal', 
      'totalSeatPrice', 
      'totalMealPrice', 
      'totalspecialSsrPrice', 
      'totalssrBaggagePrice'
  ];
  
  sessionKeys.forEach(key => {
      if (sessionStorage.getItem(key)) {
          sessionStorage.removeItem(key);
      }
  });
  }
  cardPassThroughNo:any=''
  @ViewChild('PassthroughPayment') PassthroughPayment!: MatSelectionList;
  CreditEnable:any='default'
onPassthroughChange(){
  this.CreditEnable=this.PassthroughPayment?.selectedOptions?.selected[0]?.value;
  
  let res:any=''
  if(this.CreditEnable==='enable'){
    res=this.cardPassThroughNo
    // if(res){
    //   this.orderUpdate(res)
    // }

  }else if(this.CreditEnable==='disable'){
    res='D'
    this.orderUpdate(res)
  }
  else if(this.CreditEnable==='default'){
    res='I'
    this.orderUpdate(res)
  }
  

}
orderSelectionUpdate(){
  this.orderUpdate(this.cardPassThroughNo)
}
orderUpdate(res:any){
  let request:any={
    passThroughCardDetails:res
  }
      this.FlightService
      .OrderId(this.orderId.orderNumber,request)
      .subscribe({
        next : (res:any) => {
          if(res) {
           let data:any
           data=res  
           if(res.passThroughInfo){
            this.orderId.passThroughInfo=res?.passThroughInfo||[]
           }
           
           this.toastMsgService.setMsg({msg : "Card Updated Successfully !",msgTitle:  "Warning", msgType : "I"});

          //  console.log(data)
          } else {    
          } 
        },error : (err) => {
    
    
        }
      }
    )
}
PassThroughCardList:any=[]
checkPassThrough:any=''
cardPassthroughList(){
  this.PaymentConfigService
  .creditPassthroughCardList(this.orderId.orderNumber)
  .subscribe({
    next : (res:any) => {

      if(res){
        let data=res
        this.checkPassThrough=data.paymentCardOwner||''
     const uniqueCards = new Set();
     this.PassThroughCardList = Array.from(
      new Map(
        data.paymentCardOptionList
          .filter((item: any) => item.card) // Filter out items without a card
          .map((item: any) => [item.card, item]) // Create [card, item] pairs
      ).values()
    );
     
   
    for(let item of this.PassThroughCardList){
if(item.status==='M'){
  this.cardPassThroughNo=item?.card

}
    }
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

paymentPGStatus:any
paymentStatus(){
  let request:any={
    serviceOrderReference:this.orderId.orderNumber,
    pgPaymentPurpose:'PB'
  }
  this.PaymentConfigService
  .paymentstatusList(request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        console.log(res)
    let data:any=res.body
    this.paymentPGStatus=data.status
    if(this.paymentPGStatus==='P'){
      this.ShowDuplicateBookings=false
      this.startPollingOrderStatus()    
}
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}


intervalId: any;

startPollingOrderStatus() {
  this.intervalId = setInterval(() => {
    this.FlightService.OrderIdStatus(this.orderId.orderNumber).subscribe({
      next: (res: any) => {
        if (res) {
        let   data:any=res.result
          const status = data?.status; // replace 'status' with actual key if different

          if (status === 'B' || status === 'Z') {
            this.pnrRetreive()
            this.startTimer()
            this.showNext=true
           
            this.currentStep=2
            this.clearSesson()
            clearInterval(this.intervalId); // stop polling if status is not B or Z
          }else if(status === 'F'||status === 'T'){
            clearInterval(this.intervalId); // stop polling if status is not B or Z
            // this.onModifyClick(this.orderId.orderNumber)
        
            this.Router.navigate(['/app/modify-cart'], {
              queryParams: { id: this.orderId.orderNumber }
            });
            

          }
        }else{
          clearInterval(this.intervalId); // stop polling if status is not B or Z

        }
      },
      error: (err) => {
        console.error(err);
        clearInterval(this.intervalId); // Stop polling on error

      }
    });
  }, 2000); // every 2 seconds
}
EnablePG(){
  let requests:any={}
  requests["paymentMedium"]="PG";

  requests["ticketIssuance"]=this.ticketIssuance?.selectedOptions?.selected[0]?.value;

this.FlightService
.OrderId(this.orderId.orderNumber,requests)
.subscribe({
  next : (res:any) => {
    if(res) {
     let data:any
     data=res  

     
    //  console.log(data)
    
    
    } else {    
    } 
  },error : (err) => {


  }
}
)
}


ngOnDestroy() {
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }
}
checkCardInPassThrough(){
  if (this.orderId.passThroughInfo?.some((info:any) => info.paymentMedium === 'R')) {
    // Do something if at least one item has type 'CARD'
    console.log('CARD type found!');
    return true
  }
  return false
}

getFilteredCards(): string {
  return this.PassThroughCardList
    .filter((item:any) => item.status === 'M')
    .map((item:any) => item.card)
    .join(' / ');
}


OrderUpdate(){
  this.showSpiner=true

  let gstDetial:any={
    "bookingGstData" :{
    gstNumber:this.billingEntity?.entityGST||null,
    gstAddress:this.billingEntity?.address||null,
    gstName:this.billingEntity?.gstName||null,
    gstContactNumber:this.billingEntity?.phone||null,
    gstEmail:this.billingEntity?.email||null,
}
  }

this.FlightService
.OrderId(this.orderId.orderNumber,gstDetial)
.subscribe({
  next : (res:any) => {
    if(res) {
     let data:any
     data=res  

     this.bookingData()
    //  console.log(data)
    
    
    } else {    
    } 
  },error : (err) => {
this.showSpiner=false

  }
}
)
}

}
